import "./bootstrap";
import "../css/app.css";

import { createApp, h, getCurrentInstance, watch } from "vue";
import "@mdi/font/css/materialdesignicons.css";
import { createInertiaApp, Link, Head } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { Inertia } from "@inertiajs/inertia";
import { VSkeletonLoader } from "vuetify/components";
// import { VSkeletonLoader } from "vuetify/labs/VSkeletonLoader";

import {
  VStepper,
  VStepperWindow,
  VStepperWindowItem,
  VStepperItem,
  VStepperActions,
  VStepperHeader,
// } from "vuetify/labs/VStepper";
} from "vuetify/components";
import { setupCalendar } from "v-calendar";
import {
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelTitle,
  VExpansionPanelText,
  VDivider,
  VCheckbox,
  VDialog,
  VLazy,
  VOverlay,
  VTable,
  VSnackbar,
  VMenu,
  VProgressLinear,
  VProgressCircular,
  VListItem,
  VList,
  VListItemTitle,
  VTooltip,
  VSwitch,
} from "vuetify/components";
import VueTheMask from "vue-the-mask";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
// import { store } from "@/store/index.js";
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/vue.m";
import "./main.scss";

import CKEditor from "@ckeditor/ckeditor5-vue";

// import "vuetify/styles"; // Might want to reconsider this if you only want to import styles from specific components
import { createVuetify } from "vuetify"; // Import only VTabs and VTab
import * as directives from "vuetify/directives"; // You might want to fine-tune this as well
axios.defaults.withCredentials = true;

import { createPinia, setActivePinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useAuthStore } from '@/stores/auth/authStore';
import { getToken } from '@/helpers/localStorageHelper';
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
setActivePinia(pinia);
const authStore = useAuthStore();

const vuetify = createVuetify({
  components: {
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelTitle,
    VExpansionPanelText,
    VStepper,
    VCheckbox,
    VDialog,
    VSkeletonLoader,
    VTable,
    VOverlay,
    VSwitch,
    VMenu,
    VListItem,
    VList,
    VListItemTitle,
    VStepperWindow,
    VTooltip,
    VProgressLinear,
    VLazy,
    VSnackbar,
    VStepperWindowItem,
    VStepperHeader,
    VStepperActions,
    VStepperItem,
    VProgressCircular,
    VDivider,
  },
  directives,
});

const appName =
  window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

// import Echo from "laravel-echo";
// import Pusher from "pusher-js"; // Import Pusher

// window.Pusher = Pusher;

// window.Echo = new Echo({
//   broadcaster: "pusher",
//   key: "your-app-key", // Replace with your Pusher app key
//   cluster: "mt1", // Replace with your Pusher cluster
//   encrypted: false, // Use HTTPS for communication (recommended)
// });

// import Echo from "laravel-echo";
// import Pusher from "pusher-js";

// window.Pusher = Pusher;

// const options = {
//   broadcaster: "pusher",
//   key: "your-app-key",
//   cluster: "mt1",
// };

// window.Echo = new Echo({
//   ...options,
//   client: new Pusher(options.key, options),
// });

import Echo from "laravel-echo";
import SocketIO from "socket.io-client";
window.io = SocketIO;
import Pusher from "pusher-js";
window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: "pusher",

  // Pull directly from your staging .env via Vite:
  key: import.meta.env.VITE_PUSHER_APP_KEY,         // e.g. "26f3ac246e128f290214"
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER, // e.g. "us2"

  forceTLS: true  // always use wss://<cluster>.pusher.com
});




// .listen(".server.created", function (e) {
//   console.log("Event received:", e);
// });

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob("./Pages/**/*.vue")
    ),
    setup({ el, app, props, plugin }) {
    const vueApp = createApp({ render: () => h(app, props) })
      .use(plugin)
      .component("Link", Link)
      .component("Head", Head)
      .use(ZiggyVue, Ziggy)
      .use(vuetify)
      // .use(store)
      .use(pinia)
      .use(CKEditor)
      .use(setupCalendar, {})
      .use(VueTheMask);
    
    // Enable Vue DevTools (always enabled for debugging)
    // vueApp.config.devtools = true;
    // vueApp.config.performance = true;
      
      // Auto-load filtered global.json translations for every mounted component
      vueApp.mixin({
        async mounted() {
          try {
            const auth = useAuthStore();
            // Pass 'this' as the component instance (works for both Options and Composition API)
            // Only load if component path can be determined (client-side)
            // Per-page loading: Only loads keys for components that haven't been loaded before
            await auth.loadComponentTranslations(this, { withGlobal: true, clear: false });
            
            // Set current page path if this is a page component (for language change tracking)
            // This is already done in loadComponentTranslations, but we do it here too for safety
            const componentPath = getComponentPathFromInstance(this);
            if (componentPath && componentPath.startsWith('Pages/')) {
              auth.setCurrentPagePath(componentPath);
            }
            
            // NOTE: cleanupUnusedTranslations is now disabled for per-page loading
            // We keep all loaded keys even if not currently accessed
            // This allows returning to previously visited pages without reloading
            // Cleanup is now less aggressive and only removes truly unused keys
            // setTimeout(() => {
            //   auth.cleanupUnusedTranslations();
            // }, 1000);
          } catch (e) {
            // no-op if store not available
            console.warn('Failed to load component translations:', e);
          }
        }
      });
    
    vueApp.mount(el);
    
    return vueApp;
  },
});

InertiaProgress.init({ color: "#4B5563" });

// Helper function to extract component path from Vue component instance
function getComponentPathFromInstance(instance) {
  if (!instance) return null;
  
  // Try multiple ways to get the component file path
  let file = null;
  
  // Try Composition API style
  if (instance.type && instance.type.__file) {
    file = instance.type.__file;
  }
  // Try Options API style
  else if (instance.__file) {
    file = instance.__file;
  }
  // Try via $options
  else if (instance.$options && instance.$options.__file) {
    file = instance.$options.__file;
  }
  
  if (file) {
    const marker = "/resources/js/";
    const idx = file.lastIndexOf(marker);
    if (idx !== -1) {
      const relative = file.substring(idx + marker.length);
      return relative.replace(/\.(vue|js|ts|tsx)$/i, "").replace(/\\/g, "/");
    }
  }
  
  return null;
}

// Set up Inertia navigation listeners to load used keys on route changes
// The mixin already handles this on component mount, but this provides additional coverage
const setupInertiaListeners = () => {
  if (typeof Inertia.on === 'function') {
    // Listen to 'success' event - fires after navigation completes
    Inertia.on('success', (event) => {
      try {
        // Try multiple ways to get the page component
        const page = event?.detail?.page || event?.page || event;
        
        if (page) {
          let componentPath = null;
          
          // Method 1: Try to get component name from page
          if (page.component && typeof page.component === 'string') {
            // Convert component name like "index" or "Profile/Settings" to path
            componentPath = `Pages/${page.component}`;
          }
          
          // Method 2: Try to extract from component function
          if (!componentPath && page.component && typeof page.component === 'function') {
            const file = page.component.__file;
            if (file) {
              const marker = "/resources/js/";
              const idx = file.lastIndexOf(marker);
              if (idx !== -1) {
                const relative = file.substring(idx + marker.length);
                componentPath = relative.replace(/\.(vue|js|ts|tsx)$/i, "").replace(/\\/g, "/");
              }
            }
          }
          
          // Method 3: Try to get from page props/name
          if (!componentPath && page.props && page.props.component) {
            componentPath = `Pages/${page.props.component}`;
          }
          
          if (componentPath) {
            // console.log(`[Inertia success] Loading keys for: ${componentPath}`);
            // Set current page path for language change tracking
            if (componentPath.startsWith('Pages/')) {
              authStore.setCurrentPagePath(componentPath);
            }
            authStore.loadUsedKeysForRoute(componentPath);
          } else {
            console.warn('[Inertia success] Could not determine component path from event:', event);
          }
        }
      } catch (e) {
        console.warn('Failed to load used keys on route change:', e);
      }
    });
    
    // Also listen to 'start' event - fires when navigation begins
    Inertia.on('start', (event) => {
      // This fires before the page loads, so we can prepare
      // The actual loading happens in the mixin on mount
    });
  } else {
    console.warn('Inertia.on is not available - navigation listeners not set up');
  }
};

// Initialize Inertia listeners
setupInertiaListeners();

const updateWidth = () => {
  // store.dispatch("updateScreenWidth");
  authStore.updateScreenWidth();
};
const fetchBadWords = () => {
  // store.dispatch("fetchBadWords");
  authStore.fetchBadWords();
};
const fetchUserVersion = () => {
  // store.dispatch("fetchUserVersion");
  authStore.fetchUserVersion();
};

const fetchTranslations = () => {
  // store.dispatch("fetchTranslations");
  authStore.fetchTranslations();
};

// Initial size
updateWidth();
fetchBadWords();
fetchUserVersion();
fetchTranslations();

// Update whenever the window is resized
window.addEventListener("resize", updateWidth);

// Handle browser back button - redirect to login if user is logged out
const checkAuthAndRedirect = () => {
  const token = getToken();
  const currentPath = window.location.pathname;
  
  // List of public routes that don't require authentication
  const publicRoutes = ['/login', '/signup', '/register', '/forgot-password', '/reset-password', '/about-us', '/', '/pricing', '/gomobile', '/membership-agreement'];
  
  // If user is on a public route, don't redirect
  if (publicRoutes.includes(currentPath) || currentPath.startsWith('/password/reset')) {
    return;
  }
  
  // If no token exists and user is on a protected route, redirect to login
  if (!token) {
    Inertia.visit('/login', {
      replace: true,
      preserveState: false,
      preserveScroll: false,
    });
  }
};

// Listen for browser back/forward button (popstate event)
window.addEventListener('popstate', (event) => {
  // Small delay to ensure Inertia has processed the navigation
  setTimeout(() => {
    checkAuthAndRedirect();
  }, 100);
});

// Also check on Inertia navigation events
if (typeof Inertia.on === 'function') {
  Inertia.on('success', () => {
    // Check auth after navigation completes
    setTimeout(() => {
      checkAuthAndRedirect();
    }, 100);
  });
}
